<mat-toolbar color="primary" class="position-fixed">
    <div class="logo col-md-2">
        <img src="/assets/images/avp_icon_2.png" alt="AVP Logo">
        <span class="title">{{text.TITLE}}</span>
    </div>
    <div class="input-group col-md-2">
        <span class="icon">
            <i class="fa fa-search"></i>
        </span>
        <input 
            type="text" 
            class="form-control" 
            placeholder="{{text.REQUEST_SEARCH_TEXT}}" 
            [matAutocomplete]="auto"
            (change)="onSearch($event)">
        <mat-autocomplete #auto="matAutocomplete">
            <mat-option class="result-option" *ngFor="let request of requests" [value]="request.name" (click)="navToRequest(request)">
                <a id="ui-id-130" tabindex="-1" class="ui-menu-item-wrapper">
                    <b>{{request.name}}</b>
                    <span class="req-ctx">Nhóm: {{request.requestGroupName}}</span>
                    <small>Tạo bởi: @{{request.submitter}} — {{request.submitTime | date:'MMM d, y'}}</small>
                </a>
            </mat-option>
        </mat-autocomplete>
    </div>
    <span class="one-spacer"></span>
    <one-notification></one-notification>
    <one-management [userInfo]="userInfo"></one-management>
</mat-toolbar>